import volumeSVG from '@plone/volto/icons/volume.svg';
import type { BlockConfigBase } from '@plone/types';
import View from './View';
import Edit from './Edit';
import { MainContentReaderBlockSchema } from './schema';

export interface MainContentReaderBlockData {
  align?: 'left' | 'center' | 'right' | 'full';
}

const MainContentReaderBlockInfo: BlockConfigBase = {
  id: 'mainContentReader',
  title: 'Leitor de conteudo principal',
  icon: volumeSVG,
  group: 'common',
  view: View,
  edit: Edit,
  blockSchema: MainContentReaderBlockSchema,
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockHasOwnFocusManagement: false,
};

export default MainContentReaderBlockInfo;
